import React from "react";
import { numberToStingWithSpaces } from "../../../../utils/numberDisplayer";
import Table from "../../../../components/molecules/Table/Table";
import StatusBox from "../../../../components/atoms/StatusBox/StatusBox";
import { IconType } from "../../../../assets/JWayIcons";
import { limitString } from "../../../../utils/stringUtils";

export interface ItemCredit {
  id: string;
  title?: string;
  reference?: string;
  userFullNameRenderer?: () => React.ReactNode;
  date?: string;
  createdDate?: string;
  amount?: number;
  status?: string;
  pinColor?: string;
  withPin?: boolean;
  isChecked?: boolean;
  colorStatus?: {
    backgroundColor?: string;
    color?: string;
    iconType?: IconType;
  };
  paymentMode?: string;
  onCheck?: () => void;
  onClick?: () => void;
}

export interface CreditListViewProps {
  creditList: ItemCredit[];
  emptyMessage?: string;
  isCheckMode?: boolean;
  noUser?: boolean;
  onSelectAll?: () => void;
  onUnselectAll?: () => void;
  isAllSelected?: boolean;
  isSomeSelected?: boolean;
}

export const CreditListViewV2 = ({
  creditList,
  emptyMessage,
  isCheckMode,
  noUser,
  onSelectAll,
  onUnselectAll,
  isAllSelected,
  isSomeSelected
}: CreditListViewProps) => {
  return (
    <div>
      <Table
        emptyMessage={emptyMessage || 'Aucun crédit'}
        withCheckCase={isCheckMode}
        onSelectAll={onSelectAll}
        onUnselectAll={onUnselectAll}
        isAllSelected={isAllSelected}
        isSomeSelected={isSomeSelected}
        headerTitle={[
          "Référence",
          "Créé le",
          "Montant",
          noUser ? undefined : "Utilisateur",
          "Mode de paiement",
          "Statut"
        ].filter((item) => item !== undefined) as string[]
      }
        bodyData={creditList.map((credit) => ({
          id: credit.id,
          onRowClick: credit.onClick,
          onCheck: credit.onCheck,
          isChecked: credit.isChecked,
          data: [
            () => <span title={credit.reference || credit.title}>{limitString(credit.reference || credit.title || "", 20)}</span>,
            credit.createdDate,
            numberToStingWithSpaces(credit.amount || 0),
            noUser ? undefined : credit.userFullNameRenderer ? credit.userFullNameRenderer() : "",
            credit.paymentMode || "",
            () => (
              <StatusBox
                color={{
                  background: credit.colorStatus?.backgroundColor,
                  text: credit.colorStatus?.color,
                }}
               iconType={ credit.colorStatus?.iconType}
                size={{
                    height: "20px",
                    font: "0.7rem",
                    width: "100px",
                    lineHeight: "0.8rem"
                }}
              >
                {credit.status}
              </StatusBox>
            ),
          ].filter((item) => item !== undefined) as any[],
        }))}
      />
    </div>
  );
};

export default CreditListViewV2;

